var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var TipoProcessoEnum;
(function (TipoProcessoEnum) {
    TipoProcessoEnum["REGULARIZACAO_RURAL"] = "REGULARIZACAO_RURAL";
    TipoProcessoEnum["CERTIDAO_LEGITIMIDADE_ORIG"] = "CERTIDAO_LEGITIMIDADE_ORIG";
    TipoProcessoEnum["CERTIDAO_DOMICILIO_FISCAL_EMP_RURAL"] = "CERTIDAO_DOMICILIO_FISCAL_EMP_RURAL";
    TipoProcessoEnum["CERTIDAO_FINS_USUCAPIAO_RURAL"] = "CERTIDAO_FINS_USUCAPIAO_RURAL";
    TipoProcessoEnum["DECLARACAO_RECONHECIMENTO_LIMITES"] = "DECLARACAO_RECONHECIMENTO_LIMITES";
    TipoProcessoEnum["CERTIDAO_INTEIRO_TEOR_RURAL_URBANO"] = "CERTIDAO_INTEIRO_TEOR_RURAL_URBANO";
    TipoProcessoEnum["AVERBACAO_TITULO_JUDICIAL"] = "AVERBACAO_TITULO_JUDICIAL";
    TipoProcessoEnum["RETIFICACAO_TITULO_DEFINITIVO"] = "RETIFICACAO_TITULO_DEFINITIVO";
    TipoProcessoEnum["BUSCA_PESQUISA"] = "BUSCA_PESQUISA";
    TipoProcessoEnum["CERTIDAO_LOCALIZACAO_RURAL"] = "CERTIDAO_LOCALIZACAO_RURAL";
    TipoProcessoEnum["SOLICITAR_CARGA_COPIA_DIGITALIZADA"] = "SOLICITAR_CARGA_COPIA_DIGITALIZADA";
    TipoProcessoEnum["REGULARIZACAO_FUNDIARIA_URBANA"] = "REGULARIZACAO_FUNDIARIA_URBANA";
    TipoProcessoEnum["DECLARACAO_ASSENTADO"] = "DECLARACAO_ASSENTADO";
    TipoProcessoEnum["RATIFICACAO_TITULO_DEF_URBANO"] = "RATIFICACAO_TITULO_DEF_URBANO";
    TipoProcessoEnum["REGULARIZACAO_FUND_RURAL_ASSENTAMENTO"] = "REGULARIZACAO_FUND_RURAL_ASSENTAMENTO";
    TipoProcessoEnum["CERTIDAO_ADMINISTRATIVA"] = "CERTIDAO_ADMINISTRATIVA";
    TipoProcessoEnum["MAPA_MEMORIAL"] = "MAPA_MEMORIAL";
    TipoProcessoEnum["ESTD_CAD"] = "ESTD_CAD";
})(TipoProcessoEnum || (TipoProcessoEnum = {}));
(function (TipoProcessoEnum) {
    var mapDescricao = new Map([
        [TipoProcessoEnum.REGULARIZACAO_RURAL, 'Regularização Fundiária Rural'],
        [TipoProcessoEnum.CERTIDAO_LEGITIMIDADE_ORIG, 'Certidão de Legitimidade de Origem'],
        [TipoProcessoEnum.CERTIDAO_DOMICILIO_FISCAL_EMP_RURAL, 'Certidão de Domicilio Fiscal de Empreendimento Rural'],
        [TipoProcessoEnum.REGULARIZACAO_FUNDIARIA_URBANA, 'Regularização Fundiária Urbana'],
        [TipoProcessoEnum.CERTIDAO_FINS_USUCAPIAO_RURAL, 'Certidão para fins de Usucapião Rural'],
        [TipoProcessoEnum.DECLARACAO_RECONHECIMENTO_LIMITES, 'Declaração de Reconhecimento de Limites'],
        [TipoProcessoEnum.CERTIDAO_INTEIRO_TEOR_RURAL_URBANO, 'Certidão de Inteiro Teor Rural/Urbano'],
        [TipoProcessoEnum.AVERBACAO_TITULO_JUDICIAL, 'Averbação de Título Judicial'],
        [TipoProcessoEnum.RETIFICACAO_TITULO_DEFINITIVO, 'Retificação de Título Definitivo'],
        [TipoProcessoEnum.BUSCA_PESQUISA, 'Busca e Pesquisa'],
        [TipoProcessoEnum.CERTIDAO_LOCALIZACAO_RURAL, 'Certidão de Localização'],
        [TipoProcessoEnum.SOLICITAR_CARGA_COPIA_DIGITALIZADA, 'Carga ou Cópia Digitalizada de Processos'],
        [TipoProcessoEnum.CERTIDAO_ADMINISTRATIVA, 'Certidão Administrativa'],
        [TipoProcessoEnum.MAPA_MEMORIAL, 'Mapa e Memorial'],
        [TipoProcessoEnum.DECLARACAO_ASSENTADO, 'Declaração de Assentado'],
        [TipoProcessoEnum.RATIFICACAO_TITULO_DEF_URBANO, 'Ratificação de Título Definitivo Urbano'],
        [TipoProcessoEnum.REGULARIZACAO_FUND_RURAL_ASSENTAMENTO, 'Regularização Fundiária Rural em Assentamento'],
        [TipoProcessoEnum.ESTD_CAD, 'Estudo Cadastral'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    TipoProcessoEnum.getDescricao = getDescricao;
    function getOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoProcessoEnum.getOptions = getOptions;
    function of(str) {
        var _a;
        if (!str) {
            return null;
        }
        return ((_a = __spreadArray([], getOptions(), true).find(function (_a) {
            var label = _a.label, value = _a.value;
            return "".concat(value) === "".concat(str);
        })) === null || _a === void 0 ? void 0 : _a.value) || null;
    }
    TipoProcessoEnum.of = of;
})(TipoProcessoEnum || (TipoProcessoEnum = {}));
